import { j as a } from "./index.es52.js";
const l = ({
  header: e,
  langAriaSteps: s,
  ...n
}) => /* @__PURE__ */ a.jsxs("button", { className: "bl-accordion__header-button", tabIndex: 0, ...n, children: [
  /* @__PURE__ */ a.jsx("div", { className: "bl-accordion__icon", "aria-hidden": "true", children: /* @__PURE__ */ a.jsx("i", { className: "bl-icon--chevron-down bl-icon--small" }) }),
  s && /* @__PURE__ */ a.jsxs("span", { className: "bl-sr-only", children: [
    s,
    ":"
  ] }),
  /* @__PURE__ */ a.jsx("div", { className: "bl-accordion__header-content", children: e })
] });
export {
  l as default
};
//# sourceMappingURL=index.es187.js.map
